import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react"

const API_URL = `${process.env.REACT_APP_API_ENDPOINT}api`

export const apiV1 = createApi({
  reducerPath: "apiV1",
  baseQuery: fetchBaseQuery({
    baseUrl: API_URL,
    prepareHeaders: (headers) => {
      let token = localStorage.getItem("authUser")
      if (token) {
        token = token.replace('"', "").replace('"', "")
        headers.set("Authorization", `Bearer ${token}`)
      }
      headers.set("Content-Type", "application/json")
      headers.set("Accept", "application/json")
      return headers
    },
  }),
  endpoints: () => ({}),
})
